export { cast };
export { castProp };
function cast(_thing) { }
function castProp(_obj, prop) { }
